<template>
  <div class="">
    <div class="font-bold text-lg">ข้อมูลการขอซื้อ</div>
    <!-- เลขที่ PO: -->
    <div class="mt-4 flex flex-row lg:flex-col justify-between">
      <label class="form-label font-bold">เลขที่ PO:</label>
      <div>
        <a :href="poLinkUrl" target="_blank" class="text-theme-10">{{
          poDocNoFull
        }}</a>
      </div>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 lg:gap-4">
      <div>
        <!-- ผู้ค้า -->
        <div class="mt-2 lg:mt-4">
          <label class="form-label font-bold">ผู้ค้า:</label>
          <div>{{ vendor.code }} - {{ vendor.name }}</div>
        </div>
        <!-- ที่อยู่ -->
        <div class="mt-4">
          <label class="form-label font-bold">ที่อยู่:</label>
          <div>{{ vendor.address }}</div>
        </div>
        <!-- เบอร์โทร -->
        <div class="flex flex-row lg:flex-col justify-between mt-2 lg:mt-4">
          <label class="form-label font-bold">โทร:</label>
          <div>{{ vendor.telephone }}</div>
        </div>
        <!-- Email -->
        <div class="flex flex-row lg:flex-col justify-between mt-0 lg:mt-4 ">
          <label class="form-label font-bold">Email:</label>
          <div>{{ vendor.email }}</div>
        </div>
      </div>
      <div>
        <!-- ใบสั่งซื้อ/สัญญา -->
        <div class="flex flex-row lg:flex-col justify-between mt-0 lg:mt-4 ">
          <label class="form-label font-bold">ใบสั่งซื้อ/สัญญา:</label>
          <div>{{ poDocTypeText }}</div>
        </div>
        <!-- สกุลเงิน -->
        <div class="flex flex-row lg:flex-col justify-between mt-0 lg:mt-4">
          <label class="form-label font-bold">สกุลเงิน:</label>
          <div>{{ currency }}</div>
        </div>
        <!-- ชนิดของการซื้อ -->
        <div class="flex flex-row lg:flex-col justify-between mt-0 lg:mt-4">
          <label class="form-label font-bold">ชนิดของการซื้อ:</label>
          <div>{{ orderTypeText }}</div>
        </div>
        <!-- ส่วนลด -->
        <div class="flex flex-row lg:flex-col justify-between mt-0 lg:mt-4">
          <label class="form-label font-bold">ส่วนลด:</label>
          <div>{{ numberFormat(discountAllItem) }}</div>
        </div>
      </div>
    </div>
    <!-- เหตุผลในการคัดเลือกผู้ค้า -->
    <div class="mt-2 lg:mt-4">
      <label class="form-label font-bold">เหตุผลในการคัดเลือกผู้ค้า:</label>
      <div
        class="overflow-x-auto"
        v-html="
          reasonChosenVendor ? reasonChosenVendor.replaceAll('\n', '<br>') : ''
        "
      ></div>
    </div>
    <!-- รายละเอียด -->
    <div class="mt-4">
      <label class="form-label font-bold">รายละเอียด:</label>
      <div
        class="overflow-x-auto"
        v-html="reqDetail ? reqDetail.replaceAll('\n', '<br />') : ''"
      ></div>
    </div>
    <!-- ข้อสำคัญ -->
    <div class="mt-4">
      <label class="form-label font-bold">ข้อสำคัญ:</label>
      <div
        class="overflow-x-auto"
        v-html="
          importantFactor ? importantFactor.replaceAll('\n', '<br />') : ''
        "
      ></div>
    </div>
    <!-- ไฟล์แนบ -->
    <div class="mt-4">
      <label class="form-label font-bold">ไฟล์แนบ:</label>
      <AttachFilePreview :data="fileAttachArray" grid />
    </div>
    <div class="mt-4">
      <label class="form-label font-bold">Memo:</label>
      <div v-if="memo.id">
        <a :href="memo.link" target="_blank">{{ memo.title }}</a>
      </div>
      <div v-else>-</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, toRefs, computed } from 'vue'
import helpers from '@/helpers'
import AttachFilePreview from '@/components/attach-file/Preview.vue'

export default defineComponent({
  name: 'detail-gr',
  components: {
    AttachFilePreview
  },
  props: {
    poDocNoFull: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    poDocTypeText: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    reasonChosenVendor: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    currency: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    orderTypeText: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    discountAllItem: {
      type: Number,
      default: () => 0
    },
    reqDetail: {
      type: String,
      default: () => 'ไม่ระบุ'
    },
    vendor: {
      type: Object,
      default: () => {
        return {
          code: '',
          name: '',
          address: '',
          telephone: '',
          email: ''
        }
      }
    },
    memo: {
      type: Object,
      default: () => {
        return {
          id: null,
          title: '',
          link: null
        }
      }
    },
    fileAttachArray: {
      type: Array,
      default: () => []
    },
    importantFactor: {
      type: String,
      default: () => ''
    },
    poId: {
      type: String,
      default: () => null
    }
  },
  setup(props) {
    const { numberFormat } = helpers
    // const computed(() => {{ process.env.VUE_APP_API_URL }}/procument/po/form/{{ poId )
    const poLinkUrl = computed(
      () =>
        `${process.env.VUE_APP_BASE_URL}/procurement/po/form/${props.poId}/detail`
    )

    return {
      ...toRefs(props),
      numberFormat,
      poLinkUrl
    }
  }
})
</script>

<style scoped></style>
